const colorToggleBtn = document.querySelector('.js-toggle-color-mode');
const matched = window.matchMedia('(prefers-color-scheme: dark)').matches;

colorToggleBtn.addEventListener('click', () => {
    let state = readLocalStorage('darkMode');
    if (state === "true") { state = "false"} else { state = "true" }
    
    document.body.classList.toggle('darkmode');
    setLocalStorage('darkMode', state);
})

const setLocalStorage = (k, v) => {
    localStorage.setItem(k, v);
}

const readLocalStorage = (k) => {
    return localStorage.getItem(k);
}

// todo: first run, if only mached but no localstorage?

if (readLocalStorage('darkMode') === "true") {
    document.body.classList.add('darkmode');
    //console.log('localstorage = true')
    
} else if (matched && readLocalStorage('darkMode') == null) {
    //console.log('readLocalStorage', readLocalStorage('darkMode'));
    document.body.classList.add('darkmode');
    //console.log('matched')
}
